export default "__VITE_ASSET__41cfd1cc__"